/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

:host {
  display: block;
}

.#{$prefix}list-wrapper {
  position: relative;

  .#{$prefix}list {
    position: relative;
    min-height: 250px;
    display: grid;
    grid-template-columns: auto;
    grid-gap: 10px;
    opacity: 1;
    transition: opacity 0.2s ease;
  }

  .#{$prefix}preloading-overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 99;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.2s ease, visibility 0.2s ease;
  }

  &.#{$prefix}loading {
    .#{$prefix}list {
      opacity: 0.1;
    }

    .#{$prefix}paging {
      opacity: 0.1;
    }

    .#{$prefix}preloading-overlay {
      opacity: 1;
      visibility: visible;
    }
  }
}

::slotted([slot="preloader"]) {
  position: sticky;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin: 150px 0 150px 0;
}
